(() => {
  if (window.glassifyProductSliderInitialized) return;
  window.glassifyProductSliderInitialized = true;

  function initializeSection(section) {
    if (section.dataset.sliderInitialized) return;
    section.dataset.sliderInitialized = 'true';

    const tabs = Array.from(section.querySelectorAll('[role="tab"]'));
    const panels = Array.from(section.querySelectorAll('[role="tabpanel"]'));
    const previous = section.querySelector('.product-slider-prev');
    const next = section.querySelector('.product-slider-next');
    const navigation = section.querySelector('.product-slider-navigation');
    const status = section.querySelector('.product-slider-status');
    const swipers = new Map();
    const desktopMedia = window.matchMedia('(min-width: 1024px)');
    const usesDesktopGrid = () => section.dataset.desktopRows === '2' && desktopMedia.matches;
    let desktopGrid = usesDesktopGrid();
    let activeSwiper;
    let activeScroller;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const swatchRows = Array.from(section.querySelectorAll('.product-card-color-selector .color-swatches'));

    function updateSwatchHint(row) {
      const selector = row.closest('.product-card-color-selector');
      const remaining = row.scrollWidth - row.clientWidth - row.scrollLeft;
      selector.classList.toggle('has-more-colors', row.clientWidth > 0 && remaining > 1);
    }

    function updateSwatchHints() {
      swatchRows.forEach(updateSwatchHint);
    }

    const swatchResizeObserver = typeof window.ResizeObserver === 'function'
      ? new window.ResizeObserver(entries => entries.forEach(entry => updateSwatchHint(entry.target)))
      : null;
    swatchRows.forEach(row => {
      row.addEventListener('scroll', () => updateSwatchHint(row), { passive: true });
      if (swatchResizeObserver) swatchResizeObserver.observe(row);
    });
    if (!swatchResizeObserver) window.addEventListener('resize', updateSwatchHints);

    function updateNavigation() {
      const panel = panels.find(item => !item.hidden);
      if (activeSwiper) {
        navigation.hidden = activeSwiper.isLocked;
        previous.disabled = activeSwiper.isBeginning || activeSwiper.isLocked;
        next.disabled = activeSwiper.isEnd || activeSwiper.isLocked;
      } else if (activeScroller) {
        const maximum = activeScroller.scrollWidth - activeScroller.clientWidth;
        navigation.hidden = maximum <= 1;
        previous.disabled = activeScroller.scrollLeft <= 1;
        next.disabled = activeScroller.scrollLeft >= maximum - 1;
      } else {
        navigation.hidden = true;
        previous.disabled = true;
        next.disabled = true;
      }
      if (panel) {
        previous.setAttribute('aria-controls', panel.id);
        next.setAttribute('aria-controls', panel.id);
      }
    }

    function activateTab(tab, focus = false) {
      const panelId = tab.getAttribute('aria-controls');
      tabs.forEach(item => {
        const selected = item === tab;
        item.classList.toggle('active', selected);
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      panels.forEach(panel => { panel.hidden = panel.id !== panelId; });
      const panel = panels.find(item => item.id === panelId);
      const slider = panel && panel.querySelector('.product-slider-swiper');
      activeSwiper = null;
      activeScroller = null;

      if (slider && !desktopGrid && typeof window.Swiper === 'function') {
        if (!swipers.has(slider)) {
          swipers.set(slider, new window.Swiper(slider, {
            slidesPerView: 1.35,
            slidesPerGroup: 1,
            spaceBetween: 16,
            watchOverflow: true,
            speed: reducedMotion ? 0 : 300,
            a11y: {
              enabled: true,
              containerRoleDescriptionMessage: 'Produktrække',
              itemRoleDescriptionMessage: 'Produkt',
              slideLabelMessage: 'Produkt {{index}} af {{slidesLength}}'
            },
            breakpoints: {
              480: { slidesPerView: 2.2, spaceBetween: 20 },
              768: { slidesPerView: 3, spaceBetween: 24 },
              1280: { slidesPerView: 4, spaceBetween: 28 }
            },
            on: {
              slideChange: updateNavigation,
              resize: updateNavigation,
              lock: updateNavigation,
              unlock: updateNavigation
            }
          }));
        }
        activeSwiper = swipers.get(slider);
        activeSwiper.update();
      } else if (slider) {
        activeScroller = slider.querySelector('.swiper-wrapper');
      }
      updateNavigation();
      updateSwatchHints();
      if (status) status.textContent = '';
      if (focus) tab.focus();
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tab));
      tab.addEventListener('keydown', event => {
        let target;
        if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = tabs.length - 1;
        if (target !== undefined) {
          event.preventDefault();
          activateTab(tabs[target], true);
        }
      });
    });
    panels.forEach(panel => {
      const scroller = panel.querySelector('.swiper-wrapper');
      if (!scroller) return;
      scroller.addEventListener('scroll', updateNavigation, { passive: true });
      scroller.addEventListener('keydown', event => {
        if (event.target !== scroller) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      });
    });
    function move(direction) {
      if (activeSwiper) {
        if (direction < 0) activeSwiper.slidePrev();
        else activeSwiper.slideNext();
      } else if (activeScroller) {
        const slides = activeScroller.querySelectorAll('.swiper-slide');
        if (slides.length < 2) return;
        // In the desktop grid, the first two products share a column.
        const nextColumn = Array.from(slides).find(slide => slide.offsetLeft > slides[0].offsetLeft);
        if (!nextColumn) return;
        const step = nextColumn.offsetLeft - slides[0].offsetLeft;
        activeScroller.scrollBy({
          left: direction * step,
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      }
    }
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    function handleResize() {
      const nextDesktopGrid = usesDesktopGrid();
      if (nextDesktopGrid !== desktopGrid) {
        desktopGrid = nextDesktopGrid;
        swipers.forEach(swiper => swiper.destroy(true, true));
        swipers.clear();
        panels.forEach(panel => {
          const scroller = panel.querySelector('.swiper-wrapper');
          if (scroller) scroller.scrollLeft = 0;
        });
        const selectedTab = tabs.find(tab => tab.getAttribute('aria-selected') === 'true');
        if (selectedTab) activateTab(selectedTab);
      }
      updateNavigation();
    }
    window.addEventListener('resize', handleResize);

    section.querySelectorAll('.color-swatch[data-product-id]').forEach(swatch => {
      swatch.addEventListener('click', () => {
        const card = swatch.closest('.product-card');
        const data = swatch.dataset;
        if (!card || !data.productImage) return;
        const image = new Image();
        card.dataset.pendingProduct = data.productId;
        card.setAttribute('aria-busy', 'true');
        if (status) status.textContent = '';

        image.onload = () => {
          if (card.dataset.pendingProduct !== data.productId) return;
          card.removeAttribute('aria-busy');
          card.querySelectorAll('.color-swatch').forEach(item => {
            const selected = item === swatch;
            item.classList.toggle('is-active', selected);
            item.setAttribute('aria-pressed', String(selected));
          });
          const firstImage = card.querySelector('.first-image-trigger');
          const secondImage = card.querySelector('.second-image-trigger');
          const titleParts = (data.productTitle || '').replace(/ – /g, ' - ').split(' - ');
          const title = titleParts.shift();
          [firstImage, secondImage].forEach((element, index) => {
            if (!element) return;
            element.src = index === 0 ? data.productImage : data.productSecondImage || data.productImage;
            element.removeAttribute('srcset');
            element.alt = data.productTitle || '';
          });
          const titleElement = card.querySelector('.product-card__title');
          const detail = card.querySelector('.product-card__detail');
          if (titleElement) titleElement.textContent = title;
          if (detail) detail.textContent = titleParts.join(' · ');
          const price = card.querySelector('.product-card__price');
          if (price && data.priceHtml !== undefined) price.innerHTML = data.priceHtml;
          const badges = card.querySelector('.tag-container');
          if (badges && data.badgesHtml !== undefined) badges.innerHTML = data.badgesHtml;
          const logo = card.querySelector('.brand-logo-collection');
          if (logo) {
            logo.hidden = !data.productLogo;
            if (data.productLogo) logo.src = data.productLogo;
            else logo.removeAttribute('src');
            logo.alt = data.productVendor || '';
          }
          card.querySelectorAll('a').forEach(link => { link.href = data.productUrl; });
          if (status) {
            status.classList.remove('product-slider-status--error');
            status.textContent = `${data.productTitle} valgt.`;
          }
        };
        image.onerror = () => {
          if (card.dataset.pendingProduct !== data.productId) return;
          card.removeAttribute('aria-busy');
          if (status) {
            status.classList.add('product-slider-status--error');
            status.textContent = 'Vi kunne ikke hente denne farve. Prøv igen.';
          }
        };
        image.src = data.productImage;
      });
    });

    if (tabs[0]) activateTab(tabs[0]);
    section.addEventListener('product-slider:destroy', () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('resize', updateSwatchHints);
      if (swatchResizeObserver) swatchResizeObserver.disconnect();
      swipers.forEach(swiper => swiper.destroy(true, true));
    }, { once: true });
  }

  function initializeAll(root = document) {
    root.querySelectorAll('.product-slider').forEach(initializeSection);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.product-slider').forEach(section => {
      section.dispatchEvent(new Event('product-slider:destroy'));
    });
  });
})();
